/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ErrorResponse,
  PaginatedSimilarPlaylistList,
  PaginatedYouTubeMetadataSuggestionList,
  PlaylistSimilarPlaylistsParams,
  PlaylistYoutubeSuggestionsList2Params,
  PlaylistYoutubeSuggestionsListParams,
  YouTubeMetadataSuggestionCreateRequest,
  YouTubeMetadataSuggestionSelectRequest,
  YouTubeURLUpdateRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 크로스 프로모션을 위한 유사 플레이리스트를 조회합니다.
 * @summary 유사 플레이리스트 조회
 */
export const playlistSimilarPlaylists = (
  id: string,
  params?: PlaylistSimilarPlaylistsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedSimilarPlaylistList>(
    {
      url: `/api/playlists/${id}/similar-playlists/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistSimilarPlaylistsQueryKey = (
  id?: string,
  params?: PlaylistSimilarPlaylistsParams,
) => {
  return [
    `/api/playlists/${id}/similar-playlists/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlaylistSimilarPlaylistsQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistSimilarPlaylistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlaylistSimilarPlaylistsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistSimilarPlaylists>>
  > = ({ signal }) =>
    playlistSimilarPlaylists(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistSimilarPlaylistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistSimilarPlaylists>>
>;
export type PlaylistSimilarPlaylistsQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistSimilarPlaylists<
  TData = Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | PlaylistSimilarPlaylistsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
          TError,
          Awaited<ReturnType<typeof playlistSimilarPlaylists>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistSimilarPlaylists<
  TData = Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistSimilarPlaylistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
          TError,
          Awaited<ReturnType<typeof playlistSimilarPlaylists>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistSimilarPlaylists<
  TData = Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistSimilarPlaylistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 유사 플레이리스트 조회
 */

export function usePlaylistSimilarPlaylists<
  TData = Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistSimilarPlaylistsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistSimilarPlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistSimilarPlaylistsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 모든 YouTube 메타데이터 추천을 조회합니다.
 * @summary YouTube 메타데이터 추천 목록 조회
 */
export const playlistYoutubeSuggestionsList = (
  id: string,
  params?: PlaylistYoutubeSuggestionsListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedYouTubeMetadataSuggestionList>(
    {
      url: `/api/playlists/${id}/youtube-suggestions/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistYoutubeSuggestionsListQueryKey = (
  id?: string,
  params?: PlaylistYoutubeSuggestionsListParams,
) => {
  return [
    `/api/playlists/${id}/youtube-suggestions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPlaylistYoutubeSuggestionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistYoutubeSuggestionsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPlaylistYoutubeSuggestionsListQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>
  > = ({ signal }) =>
    playlistYoutubeSuggestionsList(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaylistYoutubeSuggestionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>
>;
export type PlaylistYoutubeSuggestionsListQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function usePlaylistYoutubeSuggestionsList<
  TData = Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params: undefined | PlaylistYoutubeSuggestionsListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
          TError,
          Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistYoutubeSuggestionsList<
  TData = Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistYoutubeSuggestionsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
          TError,
          Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePlaylistYoutubeSuggestionsList<
  TData = Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistYoutubeSuggestionsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary YouTube 메타데이터 추천 목록 조회
 */

export function usePlaylistYoutubeSuggestionsList<
  TData = Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  params?: PlaylistYoutubeSuggestionsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof playlistYoutubeSuggestionsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPlaylistYoutubeSuggestionsListQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플레이리스트의 모든 YouTube 메타데이터 추천을 조회합니다.
 * @summary YouTube 메타데이터 추천 목록 조회
 */
export const playlistYoutubeSuggestionsList2 = (
  id: string,
  youTubeMetadataSuggestionCreateRequest: BodyType<YouTubeMetadataSuggestionCreateRequest>,
  params?: PlaylistYoutubeSuggestionsList2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedYouTubeMetadataSuggestionList>(
    {
      url: `/api/playlists/${id}/youtube-suggestions/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: youTubeMetadataSuggestionCreateRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPlaylistYoutubeSuggestionsList2MutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>,
    TError,
    {
      id: string;
      data: BodyType<YouTubeMetadataSuggestionCreateRequest>;
      params?: PlaylistYoutubeSuggestionsList2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>,
  TError,
  {
    id: string;
    data: BodyType<YouTubeMetadataSuggestionCreateRequest>;
    params?: PlaylistYoutubeSuggestionsList2Params;
  },
  TContext
> => {
  const mutationKey = ["playlistYoutubeSuggestionsList2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>,
    {
      id: string;
      data: BodyType<YouTubeMetadataSuggestionCreateRequest>;
      params?: PlaylistYoutubeSuggestionsList2Params;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return playlistYoutubeSuggestionsList2(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistYoutubeSuggestionsList2MutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>
>;
export type PlaylistYoutubeSuggestionsList2MutationBody =
  BodyType<YouTubeMetadataSuggestionCreateRequest>;
export type PlaylistYoutubeSuggestionsList2MutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 메타데이터 추천 목록 조회
 */
export const usePlaylistYoutubeSuggestionsList2 = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>,
      TError,
      {
        id: string;
        data: BodyType<YouTubeMetadataSuggestionCreateRequest>;
        params?: PlaylistYoutubeSuggestionsList2Params;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistYoutubeSuggestionsList2>>,
  TError,
  {
    id: string;
    data: BodyType<YouTubeMetadataSuggestionCreateRequest>;
    params?: PlaylistYoutubeSuggestionsList2Params;
  },
  TContext
> => {
  const mutationOptions =
    getPlaylistYoutubeSuggestionsList2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 기본 언어의 YouTube 메타데이터를 기반으로 각 국가별 문화/SEO를 고려한 로컬라이제이션을 생성합니다. 단순 번역이 아닌, 클릭을 유도하는 적응형 변환입니다.
 * @summary YouTube 메타데이터 AI 로컬라이제이션
 */
export const playlistLocalizeYoutubeMetadata = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/youtube-suggestions/localize/`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getPlaylistLocalizeYoutubeMetadataMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["playlistLocalizeYoutubeMetadata"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return playlistLocalizeYoutubeMetadata(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistLocalizeYoutubeMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>
>;

export type PlaylistLocalizeYoutubeMetadataMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 메타데이터 AI 로컬라이제이션
 */
export const usePlaylistLocalizeYoutubeMetadata = <
  TError = ErrorType<
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistLocalizeYoutubeMetadata>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getPlaylistLocalizeYoutubeMetadataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 YouTube 메타데이터 추천을 선택하여 플레이리스트에 적용합니다.
 * @summary YouTube 메타데이터 추천 선택
 */
export const playlistSelectYoutubeSuggestion = (
  id: string,
  youTubeMetadataSuggestionSelectRequest: BodyType<YouTubeMetadataSuggestionSelectRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/youtube-suggestions/select/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: youTubeMetadataSuggestionSelectRequest,
      signal,
    },
    options,
  );
};

export const getPlaylistSelectYoutubeSuggestionMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>,
    TError,
    { id: string; data: BodyType<YouTubeMetadataSuggestionSelectRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>,
  TError,
  { id: string; data: BodyType<YouTubeMetadataSuggestionSelectRequest> },
  TContext
> => {
  const mutationKey = ["playlistSelectYoutubeSuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>,
    { id: string; data: BodyType<YouTubeMetadataSuggestionSelectRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistSelectYoutubeSuggestion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistSelectYoutubeSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>
>;
export type PlaylistSelectYoutubeSuggestionMutationBody =
  BodyType<YouTubeMetadataSuggestionSelectRequest>;
export type PlaylistSelectYoutubeSuggestionMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube 메타데이터 추천 선택
 */
export const usePlaylistSelectYoutubeSuggestion = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>,
      TError,
      { id: string; data: BodyType<YouTubeMetadataSuggestionSelectRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistSelectYoutubeSuggestion>>,
  TError,
  { id: string; data: BodyType<YouTubeMetadataSuggestionSelectRequest> },
  TContext
> => {
  const mutationOptions =
    getPlaylistSelectYoutubeSuggestionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * YouTube에 업로드한 후 비디오 URL을 등록합니다.
 * @summary YouTube URL 등록
 */
export const playlistYoutubeUrlUpdate = (
  id: string,
  youTubeURLUpdateRequest: BodyType<YouTubeURLUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    {
      url: `/api/playlists/${id}/youtube-url/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: youTubeURLUpdateRequest,
    },
    options,
  );
};

export const getPlaylistYoutubeUrlUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>,
    TError,
    { id: string; data: BodyType<YouTubeURLUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>,
  TError,
  { id: string; data: BodyType<YouTubeURLUpdateRequest> },
  TContext
> => {
  const mutationKey = ["playlistYoutubeUrlUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>,
    { id: string; data: BodyType<YouTubeURLUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return playlistYoutubeUrlUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaylistYoutubeUrlUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>
>;
export type PlaylistYoutubeUrlUpdateMutationBody =
  BodyType<YouTubeURLUpdateRequest>;
export type PlaylistYoutubeUrlUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary YouTube URL 등록
 */
export const usePlaylistYoutubeUrlUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>,
      TError,
      { id: string; data: BodyType<YouTubeURLUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playlistYoutubeUrlUpdate>>,
  TError,
  { id: string; data: BodyType<YouTubeURLUpdateRequest> },
  TContext
> => {
  const mutationOptions = getPlaylistYoutubeUrlUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
